import React from 'react';

import { ItemModel, ReassuranceModel } from '@/models';

import ReassuranceDesktop from '@/components/product/ReassuranceDesktop';
import ReassuranceMobile from '@/components/product/ReassuranceMobile';

type ReassuranceProps = {
  isDesktop: boolean;
  reassurances: ReassuranceModel[];
  currentItem: ItemModel;
  isAlert: boolean;
}

const Reassurance = ({ isDesktop, reassurances, currentItem, isAlert = false }: ReassuranceProps): React.JSX.Element => {
  const alertPrimeur = isAlert ? 'P' : '';

  return isDesktop ? (
    <ReassuranceDesktop
      reassurances={reassurances}
      currentItem={currentItem}
      alertPrimeur={alertPrimeur}
    />
  ) : (
    <ReassuranceMobile
      reassurances={reassurances}
      currentItem={currentItem}
      alertPrimeur={alertPrimeur}
    />
  );
};

export default Reassurance;
